module.exports = __webpack_public_path__ + "img/3.352edb20.png";